export const containsSpecialChars = str => {
  const specialChars = /[`!@#$%^&*()+=\[\]{};':"\\|,.<>\/?~]/;
  return specialChars.test(str);
}

export const isValidRoomId = roomId => !containsSpecialChars(roomId);
